export enum SetColorEnum {
  SET_1 = 'SET_1',
  SET_2 = 'SET_2',
  SET_3 = 'SET_3',
  SET_4 = 'SET_4',
}
